import { Injectable } from '@angular/core';
import { AxiosService } from './axios.service';
import { DELETE_FILE } from '../constants/mutation-constant';
import { DeleteFileResponse } from '@app/shared/models/Job';
import { GET_NAYAX_CHECKOUT, OPERATION } from '../constants/query-constant';

@Injectable({
  providedIn: 'root'
})
export class ApiJobService {

  constructor(
    private axiosService: AxiosService
  ) { }

  deleteJob(variable, header, accountId: number): Promise<DeleteFileResponse>{
    return this.axiosService.postByCustomHeader(DELETE_FILE,  OPERATION.DeleteFile, variable, true, header, accountId);
  }

  getNayaxCheckout(variable, header, accountId: number){
    return this.axiosService.postByCustomHeader(GET_NAYAX_CHECKOUT, OPERATION.GetNayaxCheckout, variable, false, header, accountId);
  }
}
